﻿import { Grid } from '@mui/material';
import { FC, useEffect } from 'react';
import { useState } from 'react';
import Swal from 'sweetalert2';
import { CustomerCommand } from '../../../../services/command';
import TimeHelper from '../../../../utils/time';
import { CommunicationPreferenceGrid } from './CommunicationPreferenceGrid';
import { useTranslation } from 'react-i18next';
interface IProps {
    datas?: any;
    labelText?: any;
}

export const CommunicationPreference: FC<IProps> = ({ datas }) => {
    const [smsHistoryList, setSmsHistoryList] = useState<any>([]);
    const [mailHistoryList, setMailHistoryList] = useState<any>([]);
    const [callHistoryList, setCallHistoryList] = useState<any>([]);
    const [smsHistory, setSmsHistory] = useState<any>([]);
    const [mailHistory, setMailHistory] = useState<any>([]);
    const [callHistory, setCallHistory] = useState<any>([]);
    const [switchStatusObject, setSwitchStatusObject] = useState<any>();
    const [refresh, setRefresh] = useState(false);
    const refreshList = () => {
        setRefresh((prevLoading) => !prevLoading);
    };
    const { t } = useTranslation();

    const GetCustomerOptInByCustomerId = async () => {
        CustomerCommand.GetCustomerOptInByCustomerId(datas.customer.customerId).then((res: any) => {
            if (res?.data) {
                setSwitchStatusObject({
                    ...switchStatusObject,
                    emailStatus: res.data.emailOptIn,
                    callStatus: res.data.callOptIn,
                    smsStatus: res.data.smsOptIn,
                });
            }
        });
    };
    const GetCustomerOptInByCustomerIdList = async () => {
        CustomerCommand.GetOptHistoryList(datas.customer.customerId).then((res: any) => {
            if (res.data) {
                let parseData =
                    res.data.smsHistoryList &&
                    res.data.smsHistoryList?.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.date) || '-',
                            source: item.source || '-',
                            platform: item.project || '',
                            state: item.typeValue || '',
                            validateNumber: item.consentValue || '-',
                            ip: item.ipAddress || '-',
                            device: item.userAgent || '-',
                        };
                    });
                setSmsHistoryList(parseData || []);
                setSmsHistory(res.data.smsInfo);
                let parseDataMail =
                    res.data.mailHistoryList &&
                    res.data.mailHistoryList?.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.date) || '-',
                            source: item.source || '-',
                            platform: item.project || '',
                            state: item.typeValue || '',
                            validateNumber: item.consentValue || '-',
                            ip: item.ipAddress || '-',
                            device: item.longitude || '-',
                        };
                    });
                setMailHistoryList(parseDataMail || []);
                setMailHistory(res.data.mailInfo);

                let parseDataCall =
                    res.data.callHistoryList &&
                    res.data.callHistoryList?.map((item: any) => {
                        return {
                            date: TimeHelper.formatDateHour(item.date) || '-',
                            source: item.source || '-',
                            platform: item.project || '',
                            state: item.typeValue || '',
                            ip: item.ipAddress || '-',
                        };
                    });
                setCallHistoryList(parseDataCall || []);
                setCallHistory(res.data.callInfo);
            }
        });
    };
    const checkIsStatusChanged = () => {
        if (!switchStatusObject || switchStatusObject === undefined) {
            return false;
        }
        const isEmailStatusChanged =
            mailHistory.optIn !== undefined && switchStatusObject.emailStatus !== mailHistory.optIn;
        const isSmsStatusChanged = smsHistory.optIn !== undefined && switchStatusObject.smsStatus !== smsHistory.optIn;
        const isCallStatusChanged =
            callHistory.optIn !== undefined && switchStatusObject.callStatus !== callHistory.optIn;
        return isEmailStatusChanged || isSmsStatusChanged || isCallStatusChanged;
    };

    useEffect(() => {
        GetCustomerOptInByCustomerId();
    }, []);

    useEffect(() => {
        GetCustomerOptInByCustomerIdList();
    }, [refresh]);

    useEffect(() => {
        if (checkIsStatusChanged()) {
            let req = {
                customerId: datas.customer.customerId,
                EmailOptIn: switchStatusObject.emailStatus,
                SmsOptIn: switchStatusObject.smsStatus,
                CallOptIn: switchStatusObject.callStatus,
            };
            CustomerCommand.UpdateCustomerOptIn(req).then((res: any) => {
                if (res) {
                    console.info(res.error);

                    if (res.error) {
                        Swal.fire('', res.error, 'error');
                    } else {
                        Swal.fire({
                            icon: res.statuscode == 200 ? 'success' : 'error',
                            timer: 900,
                        });
                    }
                    refreshList();
                }
            });
        }
    }, [switchStatusObject]);

    return (
        <Grid container justifyContent={'space-between'} style={{ padding: '1rem', backgroundColor: 'white' }}>
            <p>{t('customerInformation.communicationPreferces')}</p>
            {switchStatusObject && (
                <Grid
                    style={{ padding: '1rem' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <CommunicationPreferenceGrid
                        switchStatusObject={switchStatusObject}
                        statusName="smsStatus"
                        setSwitchStatusObject={setSwitchStatusObject}
                        infoList={smsHistoryList || []}
                        info={smsHistory}
                        labelText="Sms"
                    ></CommunicationPreferenceGrid>
                    <CommunicationPreferenceGrid
                        switchStatusObject={switchStatusObject}
                        infoList={mailHistoryList || []}
                        statusName="emailStatus"
                        setSwitchStatusObject={setSwitchStatusObject}
                        info={mailHistory}
                        labelText="Mail"
                    ></CommunicationPreferenceGrid>
                    <CommunicationPreferenceGrid
                        switchStatusObject={switchStatusObject}
                        infoList={callHistoryList || []}
                        statusName="callStatus"
                        setSwitchStatusObject={setSwitchStatusObject}
                        info={callHistory}
                        labelText={t('customerInformation.call')}
                    ></CommunicationPreferenceGrid>
                </Grid>
            )}
        </Grid>
    );
};

